import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import PaymentModal from "../../Advertisepayment/Advertiseplan";
import CompanyLogo from "../../../common/CompanyLogo";
function Advertise() {
  const [showModal, setShowModal] = useState(false);
  return (
    <div>
      <CompanyLogo
        title={"More Visibility, More Business"}
        subtitle={"Advertise"}
      />
      <div className=" w-full h-32 flex  items-center justify-center mt-5">
        <button className="border bg-primaryColor w-40 h-12 rounded-s-md text-white">
          Annual
        </button>
        <button className="border bg-subheader_background w-40 h-12">
          3 Months
        </button>
        <button className="border bg-subheader_background w-40 h-12 rounded-e-md">
          6 Months
        </button>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4  gap-8 w-full md:w-[91%] xl:[84%] 2xl:w-[75%] mx-auto">
        {[1, 2, 3, 4].map((data) => (
          <div
            key={data}
            className=" border group w-full h-auto p-3 mb-4 md:mb-0  transition duration-300  bg-[#f9f8f8] rounded-md overflow-hidden [box-shadow:inset_0_1px_1px_rgba(0,_0,_0,_.075),_0_0_8px_rgb(0_0_0_/_20%) "
          >
            <p className="flex justify-center mt-3 text-base md:text-lg ">
              Free Listing
            </p>
            <div className="flex justify-center mt-3 gap-2">
              <span className="mt-2">
                <img
                  src="../../../../../img/Rupeessymbol.png"
                  className="group-hover:filter group-hover:invert"
                />
              </span>
              <span className="text-4xl">0.00</span>
            </div>
            <p className="flex justify-center text-sm md:text-base">
              Per user per year
            </p>
            <p className="flex justify-center mt-3 text-sm md:text-base">
              Visibility & Reach - 0%
            </p>
            <p className="flex justify-center mt-2 text-sm md:text-base">
              No Update
            </p>
            <p className="flex justify-center mt-2 text-sm md:text-base">
              No Boost on Search
            </p>
            <div className="border-2 rounded-md border-gray-600 mt-3 text-center text-sm text-gray-800 py-2 cursor-pointer button button4">
              <p
                className=""
                onClick={() => setShowModal(true)}
              >
                Explore
                <FontAwesomeIcon
                  icon={faArrowRight}
                  className="ml-1 text-gray-800"
                />
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="bg-card_bg_color w-full md:w-[91%] xl:[84%] 2xl:w-[75%] mt-5 mx-auto h-auto rounded-lg">
        <div className="w-full mx-auto p-4 border rounded">
          <h2 className="text-3xl font-semibold mt-4 text-start text-text_color">
            Know What’s Included With Each Plan
          </h2>
          <hr className="mt-3" />
          <div className="overflow-x-auto mt-4 w-full">
            <table className="table-auto w-full mx-auto p-1 text-start">
              <thead>
                <tr>
                  <th className="px-2 py-2">
                    Get Priority over other business listings under
                  </th>
                  <th className="px-2 py-2 text-center">Listing Pages</th>
                  <th className="px-2 py-2 text-center">Sub Category</th>
                  <th className="px-2 py-2 text-center">Master and Sub Category</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className=" px-2 py-2">Home Page Listing</td>
                  <td className=" px-2 py-2">
                    <img
                      className="mx-auto w-6"
                      src="../../../../../img/close-circle.png"
                      alt="Close"
                    />
                  </td>
                  <td className=" px-2 py-2">
                    <img
                      className="mx-auto w-6"
                      src="../../../../../img/tick-circle.png"
                      alt="Tick"
                    />
                  </td>
                  <td className=" px-2 py-2">
                    <img
                      className="mx-auto w-6"
                      src="../../../../../img/tick-circle.png"
                      alt="Tick"
                    />
                  </td>
                </tr>
                <tr>
                  <td className=" px-2 py-2">Category Listing</td>
                  <td className=" px-2 py-2">
                    <img
                      className="mx-auto w-6"
                      src="../../../../../img/close-circle.png"
                      alt="Close"
                    />
                  </td>
                  <td className=" px-2 py-2">
                    <img
                      className="mx-auto w-6"
                      src="../../../../../img/tick-circle.png"
                      alt="Tick"
                    />
                  </td>
                  <td className=" px-2 py-2">
                    <img
                      className="mx-auto w-6"
                      src="../../../../../img/tick-circle.png"
                      alt="Tick"
                    />
                  </td>
                </tr>
                <tr>
                  <td className=" px-2 py-2">Sub Category Listing</td>
                  <td className=" px-2 py-2">
                    <img
                      className="mx-auto w-6"
                      src="../../../../../img/close-circle.png"
                      alt="Close"
                    />
                  </td>
                  <td className=" px-2 py-2">
                    <img
                      className="mx-auto w-6"
                      src="../../../../../img/tick-circle.png"
                      alt="Tick"
                    />
                  </td>
                  <td className=" px-2 py-2">
                    <img
                      className="mx-auto w-6"
                      src="../../../../../img/tick-circle.png"
                      alt="Tick"
                    />
                  </td>
                </tr>
                <tr>
                  <td className=" px-2 py-2">Lead Generation</td>
                  <td className=" px-2 py-2">
                    <img
                      className="mx-auto w-6"
                      src="../../../../../img/close-circle.png"
                      alt="Close"
                    />
                  </td>
                  <td className=" px-2 py-2">
                    <img
                      className="mx-auto w-6"
                      src="../../../../../img/tick-circle.png"
                      alt="Tick"
                    />
                  </td>
                  <td className=" px-2 py-2">
                    <img
                      className="mx-auto w-6"
                      src="../../../../../img/tick-circle.png"
                      alt="Tick"
                    />
                  </td>
                </tr>
                <tr>
                  <td className=" px-2 py-2">
                    Social Media Campaign (Facebook, LinkedIn & Instagram)
                  </td>
                  <td className=" px-2 py-2">
                    <img
                      className="mx-auto w-6"
                      src="../../../../../img/close-circle.png"
                      alt="Close"
                    />
                  </td>
                  <td className=" px-2 py-2">
                    <img
                      className="mx-auto w-6"
                      src="../../../../../img/tick-circle.png"
                      alt="Tick"
                    />
                  </td>
                  <td className=" px-2 py-2">
                    <img
                      className="mx-auto w-6"
                      src="../../../../../img/tick-circle.png"
                      alt="Tick"
                    />
                  </td>
                </tr>
                <tr>
                  <td className=" px-2 py-2">Bulk Email & SMS</td>
                  <td className=" px-2 py-2">
                    <img
                      className="mx-auto w-6"
                      src="../../../../../img/close-circle.png"
                      alt="Close"
                    />
                  </td>
                  <td className=" px-2 py-2">
                    <img
                      className="mx-auto w-6"
                      src="../../../../../img/tick-circle.png"
                      alt="Tick"
                    />
                  </td>
                  <td className=" px-2 py-2">
                    <img
                      className="mx-auto w-6"
                      src="../../../../../img/tick-circle.png"
                      alt="Tick"
                    />
                  </td>
                </tr>
                <tr>
                  <td className=" px-2 py-2">Showcase Your Email & Website</td>
                  <td className=" px-2 py-2">
                    <img
                      className="mx-auto w-6"
                      src="../../../../../img/close-circle.png"
                      alt="Close"
                    />
                  </td>
                  <td className=" px-2 py-2">
                    <img
                      className="mx-auto w-6"
                      src="../../../../../img/tick-circle.png"
                      alt="Tick"
                    />
                  </td>
                  <td className=" px-2 py-2">
                    <img
                      className="mx-auto w-6"
                      src="../../../../../img/tick-circle.png"
                      alt="Tick"
                    />
                  </td>
                </tr>
                <tr>
                  <td className=" px-2 py-2">
                    Get Instant Update over Phone, Email and SMS
                  </td>
                  <td className=" px-2 py-2">
                    <img
                      className="mx-auto w-6"
                      src="../../../../../img/close-circle.png"
                      alt="Close"
                    />
                  </td>
                  <td className=" px-2 py-2">
                    <img
                      className="mx-auto w-6"
                      src="../../../../../img/tick-circle.png"
                      alt="Tick"
                    />
                  </td>
                  <td className=" px-2 py-2">
                    <img
                      className="mx-auto w-6"
                      src="../../../../../img/tick-circle.png"
                      alt="Tick"
                    />
                  </td>
                </tr>
                <tr>
                  <td className=" px-2 py-2">
                    Get Instant Update over Phone, Email and SMS
                  </td>
                  <td className=" px-2 py-2">
                    <img
                      className="mx-auto w-6"
                      src="../../../../../img/close-circle.png"
                      alt="Close"
                    />
                  </td>
                  <td className=" px-2 py-2">
                    <img
                      className="mx-auto w-6"
                      src="../../../../../img/tick-circle.png"
                      alt="Tick"
                    />
                  </td>
                  <td className=" px-2 py-2">
                    <img
                      className="mx-auto w-6"
                      src="../../../../../img/tick-circle.png"
                      alt="Tick"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      {showModal && (
        <PaymentModal showModal={showModal} setShowModal={setShowModal} />
      )}
    </div>
  );
}

export default Advertise;
